import { RouterProvider } from 'react-router-dom';

import { ConfigProvider } from '@arco-design/web-react';
import enUS from '@arco-design/web-react/es/locale/en-US';
import ModalClose from '@dmp/assets/icons/modal-close.svg?react';
import { TenantConfig } from '@dmp/components/business/TenantConfig/TenantConfig';

import { useInitGlobalStore } from './hooks/globalStore.hooks';
import { router } from './router/router';

function App() {
  useInitGlobalStore();

  return (
    <ConfigProvider
      locale={enUS}
      prefixCls="dmp"
      componentConfig={{
        Modal: {
          closeIcon: <ModalClose />,
        },
      }}
    >
      <TenantConfig>
        <RouterProvider router={router} />
      </TenantConfig>
    </ConfigProvider>
  );
}

export default App;
